<template>
    <div id="dataContent" class="mainBox">
      <div class="header">
        <span class="headerName">主测点：</span>
        <div class="headerInput">
          <el-input  placeholder="输入项目名称（并按Enter键）"
          suffix-icon="iconfont icon-search" ></el-input></div>
        <span class="headerName">关联测点：</span>
        <div><el-button type="primary"  class="searchButton">保存</el-button></div>
      </div>
      <div class="mainContent" id="mainTabel">
        <div v-loading="Tableloading"
             element-loading-background="rgba(0, 0, 0, 0.7)"
             element-loading-text="数据正在加载，请稍等"
             element-loading-spinner="el-icon-loading">
          <el-table
            :data="tableData"
            :header-cell-style="HeaderCss"
            tooltip-effect="dark"
            stripe
            ref="tableTest"
            style="width: 100%">
            <el-table-column align="center" prop="projectName" label="主测点"></el-table-column>
            <el-table-column align="center" prop="createTime" label="关联测点"></el-table-column>
            <el-table-column align="center" prop="updateTime" label="备注"></el-table-column>
            <el-table-column align="center" prop="date" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" >备注</el-button>
                <el-button type="text" size="small" >修改</el-button>
                <el-button type="text" size="small" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "relationPoint",
        data(){
            return{
                tableData:[],
                Tableloading:false,
                measureNos:[]
            }
        },
        created(){
            this.getData()
        },
        methods:{
            getData() {
                this.$axios.get('/api/monitor/dataHistory/getQuerySet').then(res => {
                    if (res.data.status == 200) {
                        if (res.data.datas.values.measureNos) {
                            this.measureNos = res.data.datas.values.measureNos.split(',')
                        }
                    }
                })
            },
            HeaderCss(){
                return 'background:#1653BD;color:#ffffff;font-size:14px'
            },
        }
    }
</script>

<style>
  #mainTabel  .el-table__row {
    color: #ffffff;
  }
  #mainTabel .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: rgba(2,21,53,1);
  }
  #mainTabel  .el-table__body tr.el-table__row td{
    background-color: rgba(11,58,104,1) ;
  }

  /*行boder*/
  #mainTabel .el-table {
    border-right: unset;
    border-bottom:unset;
  }
  #mainTabel .el-table--border td, #mainTabel .el-table--border th{
    border-right:  1px solid #333333;
  }
  /*#table .el-table--border td,#table .el-table--border th{*/
  /*  border-left:  1px solid #333333;*/
  /*}*/
  #mainTabel .el-table td, #mainTabel .el-table th{
    border-bottom: 1px solid #333333;
  }

  #dataContent .headerInput .el-input__inner {
    background: #091B3D;
    border: 2px solid #2A4E97;
    border-radius: 6px;
    font-size: 14px;
    color: #ffffff;
  }
</style>

<style scoped>
  @import url('../../assets/css/content.css');

</style>



// WEBPACK FOOTER //
// src/components/dataManage/relationPoint.vue